import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// Content sourced verbatim from "SpinSaga_Crypto_FAQ.docx.pdf".
// Section order, headings, questions, answers, numbering and bullets are
// preserved exactly as supplied. Wording (including source typos) is kept
// unchanged to match the reference document.
const faqSections = [
  {
    headerKey: "faqPage.section1Header",
    items: [
      {
        qKey: "faqPage.section1Question1",
        aKey: "faqPage.section1Answer1",
      },
      {
        qKey: "faqPage.section1Question2",
        aKey: "faqPage.section1Answer2",
      },
      {
        qKey: "faqPage.section1Question3",
        aKey: "faqPage.section1Answer3",
      },
      {
        qKey: "faqPage.section1Question4",
        aKey: "faqPage.section1Answer4",
      },
      {
        qKey: "faqPage.section1Question5",
        aKey: "faqPage.section1Answer5",
      },
      {
        qKey: "faqPage.section1Question6",
        aKey: "faqPage.section1Answer6",
      },
    ],
  },
  {
    headerKey: "faqPage.section2Header",
    items: [
      {
        qKey: "faqPage.section2Question1",
        aKey: "faqPage.section2Answer1",
      },
      {
        qKey: "faqPage.section2Question2",
        aKey: "faqPage.section2Answer2",
      },
      {
        qKey: "faqPage.section2Question3",
        aKey: "faqPage.section2Answer3",
      },
      {
        qKey: "faqPage.section2Question4",
        aKey: "faqPage.section2Answer4",
      },
      {
        qKey: "faqPage.section2Question5",
        aKey: "faqPage.section2Answer5",
      },
      {
        qKey: "faqPage.section2Question6",
        aKey: "faqPage.section2Answer6",
      },
      {
        qKey: "faqPage.section2Question7",
        aKey: "faqPage.section2Answer7",
      },
      {
        qKey: "faqPage.section2Question8",
        aKey: "faqPage.section2Answer8",
      },
      {
        qKey: "faqPage.section2Question9",
        aKey: "faqPage.section2Answer9",
      },
      {
        qKey: "faqPage.section2Question10",
        aKey: "faqPage.section2Answer10",
      },
      {
        qKey: "faqPage.section2Question11",
        aKey: "faqPage.section2Answer11",
      },
      {
        qKey: "faqPage.section2Question12",
        aKey: "faqPage.section2Answer12",
      },
      {
        qKey: "faqPage.section2Question13",
        aKey: "faqPage.section2Answer13",
      },
      {
        qKey: "faqPage.section2Question14",
        aKey: "faqPage.section2Answer14",
      },
      {
        qKey: "faqPage.section2Question15",
        aKey: "faqPage.section2Answer15",
      },
      {
        qKey: "faqPage.section2Question16",
        aKey: "faqPage.section2Answer16",
      },
    ],
  },
  {
    headerKey: "faqPage.section3Header",
    items: [
      {
        qKey: "faqPage.section3Question1",
        aKey: "faqPage.section3Answer1",
      },
      {
        qKey: "faqPage.section3Question2",
        aKey: "faqPage.section3Answer2",
      },
      {
        qKey: "faqPage.section3Question3",
        aKey: "faqPage.section3Answer3",
      },
      {
        qKey: "faqPage.section3Question4",
        aKey: "faqPage.section3Answer4",
      },
      {
        qKey: "faqPage.section3Question5",
        aKey: "faqPage.section3Answer5",
      },
      {
        qKey: "faqPage.section3Question6",
        aKey: "faqPage.section3Answer6",
      },
      {
        qKey: "faqPage.section3Question7",
        aKey: "faqPage.section3Answer7",
      },
      {
        qKey: "faqPage.section3Question8",
        aKey: "faqPage.section3Answer8",
      },
      {
        qKey: "faqPage.section3Question9",
        aKey: "faqPage.section3Answer9",
      },
      {
        qKey: "faqPage.section3Question10",
        aKey: "faqPage.section3Answer10",
      },
      {
        qKey: "faqPage.section3Question11",
        aKey: "faqPage.section3Answer11",
      },
      {
        qKey: "faqPage.section3Question12",
        aKey: "faqPage.section3Answer12",
      },
      {
        qKey: "faqPage.section3Question13",
        aKey: "faqPage.section3Answer13",
      },
    ],
  },
  {
    headerKey: "faqPage.section4Header",
    items: [
      {
        qKey: "faqPage.section4Question1",
        aKey: "faqPage.section4Answer1",
      },
      {
        qKey: "faqPage.section4Question2",
        aKey: "faqPage.section4Answer2",
      },
      {
        qKey: "faqPage.section4Question3",
        aKey: "faqPage.section4Answer3",
      },
      {
        qKey: "faqPage.section4Question4",
        aKey: "faqPage.section4Answer4",
      },
      {
        qKey: "faqPage.section4Question5",
        aKey: "faqPage.section4Answer5",
      },
      {
        qKey: "faqPage.section4Question6",
        aKey: "faqPage.section4Answer6",
      },
      {
        qKey: "faqPage.section4Question7",
        aKey: "faqPage.section4Answer7",
      },
      {
        qKey: "faqPage.section4Question8",
        aKey: "faqPage.section4Answer8",
      },
      {
        qKey: "faqPage.section4Question9",
        aKey: "faqPage.section4Answer9",
      },
      {
        qKey: "faqPage.section4Question10",
        aKey: "faqPage.section4Answer10",
      },
      {
        qKey: "faqPage.section4Question11",
        aKey: "faqPage.section4Answer11",
      },
      {
        qKey: "faqPage.section4Question12",
        aRender: (t) => (
          <>
            {t("faqPage.section4Answer12Intro")}
            <ol>
              <li>{t("faqPage.section4Answer12Item1")}</li>
              <li>{t("faqPage.section4Answer12Item2")}</li>
              <li>{t("faqPage.section4Answer12Item3")}</li>
            </ol>
          </>
        ),
      },
    ],
  },
  {
    headerKey: "faqPage.section5Header",
    items: [
      {
        qKey: "faqPage.section5Question1",
        aKey: "faqPage.section5Answer1",
      },
      {
        qKey: "faqPage.section5Question2",
        aKey: "faqPage.section5Answer2",
      },
      {
        qKey: "faqPage.section5Question3",
        aKey: "faqPage.section5Answer3",
      },
      {
        qKey: "faqPage.section5Question4",
        aKey: "faqPage.section5Answer4",
      },
      {
        qKey: "faqPage.section5Question5",
        aKey: "faqPage.section5Answer5",
      },
      {
        qKey: "faqPage.section5Question6",
        aRender: (t) => (
          <>
            {t("faqPage.section5Answer6Intro")}
            <ul>
              <li>
                <strong>{t("faqPage.section5Answer6Item1")}</strong>
              </li>
              <li>
                <strong>{t("faqPage.section5Answer6Item2")}</strong>
              </li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    headerKey: "faqPage.section6Header",
    items: [
      {
        qKey: "faqPage.section6Question1",
        aKey: "faqPage.section6Answer1",
      },
      {
        qKey: "faqPage.section6Question2",
        aKey: "faqPage.section6Answer2",
      },
      {
        qKey: "faqPage.section6Question3",
        aKey: "faqPage.section6Answer3",
      },
      {
        qKey: "faqPage.section6Question4",
        aKey: "faqPage.section6Answer4",
      },
      {
        qKey: "faqPage.section6Question5",
        aKey: "faqPage.section6Answer5",
      },
      {
        qKey: "faqPage.section6Question6",
        aKey: "faqPage.section6Answer6",
      },
      {
        qKey: "faqPage.section6Question7",
        aKey: "faqPage.section6Answer7",
      },
      {
        qKey: "faqPage.section6Question8",
        aKey: "faqPage.section6Answer8",
      },
    ],
  },
  {
    headerKey: "faqPage.section7Header",
    items: [
      {
        qKey: "faqPage.section7Question1",
        aKey: "faqPage.section7Answer1",
      },
      {
        qKey: "faqPage.section7Question2",
        aKey: "faqPage.section7Answer2",
      },
      {
        qKey: "faqPage.section7Question3",
        aKey: "faqPage.section7Answer3",
      },
      {
        qKey: "faqPage.section7Question4",
        aKey: "faqPage.section7Answer4",
      },
      {
        qKey: "faqPage.section7Question5",
        aKey: "faqPage.section7Answer5",
      },
      {
        qKey: "faqPage.section7Question6",
        aKey: "faqPage.section7Answer6",
      },
      {
        qKey: "faqPage.section7Question7",
        aKey: "faqPage.section7Answer7",
      },
      {
        qKey: "faqPage.section7Question8",
        aKey: "faqPage.section7Answer8",
      },
      {
        qKey: "faqPage.section7Question9",
        aKey: "faqPage.section7Answer9",
      },
      {
        qKey: "faqPage.section7Question10",
        aKey: "faqPage.section7Answer10",
      },
      {
        qKey: "faqPage.section7Question11",
        aKey: "faqPage.section7Answer11",
      },
    ],
  },
  {
    headerKey: "faqPage.section8Header",
    items: [
      {
        qKey: "faqPage.section8Question1",
        aKey: "faqPage.section8Answer1",
      },
      {
        qKey: "faqPage.section8Question2",
        aKey: "faqPage.section8Answer2",
      },
      {
        qKey: "faqPage.section8Question3",
        aKey: "faqPage.section8Answer3",
      },
      {
        qKey: "faqPage.section8Question4",
        aKey: "faqPage.section8Answer4",
      },
      {
        qKey: "faqPage.section8Question5",
        aKey: "faqPage.section8Answer5",
      },
    ],
  },
  {
    headerKey: "faqPage.section9Header",
    items: [
      {
        qKey: "faqPage.section9Question1",
        aKey: "faqPage.section9Answer1",
      },
      {
        qKey: "faqPage.section9Question2",
        aKey: "faqPage.section9Answer2",
      },
      {
        qKey: "faqPage.section9Question3",
        aKey: "faqPage.section9Answer3",
      },
      {
        qKey: "faqPage.section9Question4",
        aKey: "faqPage.section9Answer4",
      },
      {
        qKey: "faqPage.section9Question5",
        aKey: "faqPage.section9Answer5",
      },
    ],
  },
  {
    headerKey: "faqPage.section10Header",
    items: [
      {
        qKey: "faqPage.section10Question1",
        aKey: "faqPage.section10Answer1",
      },
      {
        qKey: "faqPage.section10Question2",
        aKey: "faqPage.section10Answer2",
      },
      {
        qKey: "faqPage.section10Question3",
        aKey: "faqPage.section10Answer3",
      },
      {
        qKey: "faqPage.section10Question4",
        aKey: "faqPage.section10Answer4",
      },
    ],
  },
  {
    headerKey: "faqPage.section11Header",
    items: [
      {
        qKey: "faqPage.section11Question1",
        aKey: "faqPage.section11Answer1",
      },
      {
        qKey: "faqPage.section11Question2",
        aKey: "faqPage.section11Answer2",
      },
      {
        qKey: "faqPage.section11Question3",
        aKey: "faqPage.section11Answer3",
      },
      {
        qKey: "faqPage.section11Question4",
        aKey: "faqPage.section11Answer4",
      },
    ],
  },
  {
    headerKey: "faqPage.section12Header",
    items: [
      {
        qKey: "faqPage.section12Question1",
        aKey: "faqPage.section12Answer1",
      },
      {
        qKey: "faqPage.section12Question2",
        aKey: "faqPage.section12Answer2",
      },
      {
        qKey: "faqPage.section12Question3",
        aKey: "faqPage.section12Answer3",
      },
      {
        qKey: "faqPage.section12Question4",
        aKey: "faqPage.section12Answer4",
      },
      {
        qKey: "faqPage.section12Question5",
        aKey: "faqPage.section12Answer5",
      },
      {
        qKey: "faqPage.section12Question6",
        aKey: "faqPage.section12Answer6",
      },
    ],
  },
];
const Faq = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('faqPage.pageTitle')}</title>
        <meta
          name="description"
          content={t('faqPage.metaDescription')}
        />
        <link rel="canonical" href="https://coin.spinsagacasino.com/faq/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SpinSaga Casino" />
        <meta property="og:url" content="https://coin.spinsagacasino.com/faq/" />
        <meta property="og:title" content={t('faqPage.pageTitle')} />
        <meta
          property="og:description"
          content={t('faqPage.metaDescription')}
        />
        <meta property="og:image" content="https://coin.spinsagacasino.com/512x512.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('faqPage.pageTitle')} />
        <meta
          name="twitter:description"
          content={t('faqPage.metaDescription')}
        />
        <meta name="twitter:image" content="https://coin.spinsagacasino.com/512x512.png" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is SpinSaga Coin Casino?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "SpinSaga Coin Casino (coin.spinsagacasino.com) is a crypto casino where you deposit cryptocurrency to play real casino games — slots, poker, table games, and more. You play with real money, and when you win, you get paid in crypto."
                }
              },
              {
                "@type": "Question",
                "name": "How is a crypto casino different from a normal online casino?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Instead of using a bank card or bank transfer, you use cryptocurrency like Bitcoin, Ethereum, or Litecoin to fund your account. There are no bank fees, transactions are faster, and your financial details stay private."
                }
              },
              {
                "@type": "Question",
                "name": "Do I need a crypto wallet to play at SpinSaga?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes. Since SpinSaga is a crypto casino, you need a crypto wallet to deposit funds and withdraw your winnings. Without a wallet, you cannot move crypto in or out of your account."
                }
              },
              {
                "@type": "Question",
                "name": "How do I redeem my prizes / withdraw my winnings?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Go to the withdrawal or redemption section in your SpinSaga account. Enter your crypto wallet address for the coin you want to receive, enter the amount, and confirm. The crypto will be sent to your wallet once the transaction is processed."
                }
              }
            ]
          }
        `}</script>
      </Helmet>
      <div
        className="container bg-color-rg space-bottom content-only"
        style={{ marginTop: 70, padding: 20 }}
      >
        <h2>{t('faqPage.heading')}</h2>
        <p style={{ fontWeight: "bold" }}>{t('faqPage.subheading')}</p>

        {faqSections.map((section, sIndex) => (
          <div key={`faq-section-${sIndex}`} style={{ marginTop: 30 }}>
            <h3 style={{ marginBottom: 16 }}>{t(section.headerKey)}</h3>
            {section.items.map((item, iIndex) => (
              <Accordion
                key={`faq-${sIndex}-${iIndex}`}
                style={{ marginBottom: "30px" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel-${sIndex}-${iIndex}-content`}
                  id={`panel-${sIndex}-${iIndex}-header`}
                >
                  <Typography variant="body1" fontWeight="bold">
                    {t(item.qKey)}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" component="div">
                    {item.aRender ? item.aRender(t) : t(item.aKey)}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default Faq;
